import {
    LuTrash2
} from "react-icons/lu";
import { useNavigate, useParams } from "react-router-dom";
import TableInnerRowsLoading from "../Loaders/TableInnerRowsLoading";
import { TbFileSad, TbLock } from "react-icons/tb";
import { useLayoutEffect, useRef, useState } from "react";
import FormatDateTime from "../Functions/FormatDate";
import { IoOpenOutline } from "react-icons/io5";
import { useLanguage } from "../Translations/LenguageContext";

const ActionsTable = ({
    loading,
    data,
    setSelectedItem,
    setShowDeleteItem,
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate();
    const { org_id } = useParams()

    const headers = [
        t.title,
        t.description,
        t.actions.trigger_type,
        t.actions.last_run_status,
        t.actions.last_run,
        t.created_at,
        t.sidebar.actions
    ]

    return (
        <div className="custom_table_container fade-in">
            <table className="custom_table">
                <thead className="custom_table_head">
                    <tr className="custom_table_row">
                        {headers.map((header, index) => (
                            <th key={index} className="custom_table_th">
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody className="custom_table_body">
                    {loading ? (
                        <TableInnerRowsLoading />
                    ) : (
                        data.length > 0 ? (
                            data.map((item, rowIndex) => (
                                <tr key={item.id || rowIndex} className="custom_table_row">

                                    <td className="custom_table_td td_name" title={`Open action ${item.name}`} onClick={() => navigate(`/e8console/organizations/${org_id}/actions/${item.id}`)}>
                                        <IoOpenOutline />
                                        {item.name}
                                    </td>
                                    <td className="custom_table_td ">
                                        <span className="td_desc">
                                            {item.description}
                                        </span>
                                    </td>
                                    <td className="custom_table_td">
                                        {item.trigger_type ? (
                                            item.trigger_type == "scheduled" ? (
                                                "Scheduled"
                                            ) : (
                                                "One time run"
                                            )
                                        ) : (
                                            "-"
                                        )}
                                    </td>

                                    <td className="custom_table_td td_status">
                                        <div className="custom_cell_status">
                                            {item.last_run_status ? (
                                                item.last_run_status == "success" ? (
                                                    <span className="status_dot active" title="Uploaded correctly"></span>
                                                ) : (
                                                    <span className="status_dot error " title="Not uploaded - error"></span>
                                                )
                                            ) : (
                                                "-"
                                            )}
                                        </div>
                                    </td>

                                    <td className="custom_table_td">
                                        {FormatDateTime(item.last_run_at)}
                                    </td>
                                    <td className="custom_table_td">
                                        {FormatDateTime(item.created_at)}
                                    </td>

                                    <td className="custom_table_td td_actions">
                                        <button
                                            className="remove_file_btn"
                                            onClick={() => {
                                                setSelectedItem(item);
                                                setShowDeleteItem(true);
                                            }}
                                            title="Delete"
                                        >
                                            <LuTrash2 />
                                        </button>
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr className="custom_table_row_empty">
                                <td colSpan={headers.length} className="custom_table_td_empty ">
                                    <div className="custom_table_td_empty_inner fade-in">
                                        <i> <TbFileSad /></i>
                                        No data found...
                                    </div>
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ActionsTable;